import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LANGUAGE_CODE, LANGUAGES } from 'shared/constants';
import styles from './LanguageSwitch.module.scss';

const AVAILABLE_FLAGS = ['cs', 'sk', 'en'];

const LanguageSwitch = ({ size, language, onChange, dropdownPosition, className }) => {
  const { t, i18n } = useTranslation('common');
  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = (event) => {
    event.stopPropagation();
    setExpanded(prev => !prev);
  };

  const handleSelectLanguage = lang => (event) => {
    event.stopPropagation();
    i18n.changeLanguage(lang);
    onChange(lang);
    setExpanded(false);
  };

  return (
    <span className={cn(styles.wrapper, className)}>
      <input
        type="image"
        className={cn(styles.trigger, styles[size])}
        onClick={toggleExpanded}
        title={t(`languageByCode.${language}`)}
        src={`/images/flags/${language}.svg`}
        alt=""
      />
      {expanded && (
        <>
          <ul className={cn(styles.list, styles[dropdownPosition], styles[size])}>
            {AVAILABLE_FLAGS.map(key => (
              <li key={key}>
                <button type="button" title={t(`languageByCode.${key}`)} onClick={handleSelectLanguage(key)}>
                  <img src={`/images/flags/${key}.svg`} alt="" />
                </button>
              </li>
            ))}
          </ul>
          <div className={styles.outer} onClick={toggleExpanded} />
        </>
      )}
    </span>
  );
};

LanguageSwitch.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  language: PropTypes.oneOf(LANGUAGES),
  onChange: PropTypes.func,
  dropdownPosition: PropTypes.oneOf(['center', 'left', 'right']),
  className: PropTypes.string,
};

LanguageSwitch.defaultProps = {
  size: 'small',
  language: DEFAULT_LANGUAGE_CODE,
  onChange() {},
  dropdownPosition: 'center',
  className: null,
};

export default LanguageSwitch;
